function getCountryInitial(n) {
    if(n == 'en')
        return 'gb';

    return n
  }
  
  export default getCountryInitial